/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssetBody,
  AssetListBody,
  ContentsOutputBody,
  CreateFolderInputBody,
  ErrorModel,
  FolderBody,
  FoldersOutputBody,
  IDsOutputBody,
  MediaFolderUpdateHeaders,
  MediaFoldersParams,
  MediaFrameParams,
  MediaIDsParams,
  MediaListParams,
  MediaPreviewParams,
  MediaReplaceBody,
  MediaStreamParams,
  MediaUpdateHeaders,
  MediaUploadBody,
  MediaUploadChunkParams,
  MediaUploadParams,
  MoveInputBody,
  MoveOutputBody,
  OptimizationOutputBody,
  OptimizeOutputBody,
  PlaybackOutputBody,
  PosterFrameInputBody,
  PosterFrameOutputBody,
  PurgeInputBody,
  PurgeOutputBody,
  SelectionInputBody,
  SelectionOutputBody,
  SettingsBody,
  SpaceOutputBody,
  StartUploadInputBody,
  UpdateFolderInputBody,
  UpdateInputBody2,
  UploadBody,
  UsageOutputBody1
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type mediaFolderDeleteResponse204 = {
  data: void
  status: 204
}

export type mediaFolderDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaFolderDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaFolderDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaFolderDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaFolderDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaFolderDeleteResponseSuccess = (mediaFolderDeleteResponse204) & {
  headers: Headers;
};
export type mediaFolderDeleteResponseError = (mediaFolderDeleteResponse401 | mediaFolderDeleteResponse403 | mediaFolderDeleteResponse404 | mediaFolderDeleteResponse422 | mediaFolderDeleteResponse500) & {
  headers: Headers;
};

export type mediaFolderDeleteResponse = (mediaFolderDeleteResponseSuccess | mediaFolderDeleteResponseError)

export const getMediaFolderDeleteUrl = (folderId: string,) => {




  return `/media-folders/${folderId}`
}

/**
 * @summary Убрать папку в корзину вместе с содержимым
 */
export const mediaFolderDelete = async (folderId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaFolderDeleteResponse> => {

  return facetaFetch<mediaFolderDeleteResponse>(getMediaFolderDeleteUrl(folderId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMediaFolderDeleteQueryKey = (folderId: string,) => {
    return [
    'DELETE', `/media-folders/${folderId}`
    ] as const;
    }


export const getMediaFolderDeleteQueryOptions = <TData = Awaited<ReturnType<typeof mediaFolderDelete>>, TError = ErrorModel>(folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaFolderDeleteQueryKey(folderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaFolderDelete>>> = ({ signal }) => mediaFolderDelete(folderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: folderId !== null && folderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaFolderDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaFolderDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof mediaFolderDelete>>>
export type MediaFolderDeleteQueryError = ErrorModel


export function useMediaFolderDelete<TData = Awaited<ReturnType<typeof mediaFolderDelete>>, TError = ErrorModel>(
 folderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderDelete>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderDelete<TData = Awaited<ReturnType<typeof mediaFolderDelete>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderDelete>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderDelete<TData = Awaited<ReturnType<typeof mediaFolderDelete>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Убрать папку в корзину вместе с содержимым
 */

export function useMediaFolderDelete<TData = Awaited<ReturnType<typeof mediaFolderDelete>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaFolderDeleteQueryOptions(folderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaFolderUpdateResponse200 = {
  data: FolderBody
  status: 200
}

export type mediaFolderUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaFolderUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaFolderUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaFolderUpdateResponse409 = {
  data: ErrorModel
  status: 409
}

export type mediaFolderUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaFolderUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaFolderUpdateResponseSuccess = (mediaFolderUpdateResponse200) & {
  headers: Headers;
};
export type mediaFolderUpdateResponseError = (mediaFolderUpdateResponse401 | mediaFolderUpdateResponse403 | mediaFolderUpdateResponse404 | mediaFolderUpdateResponse409 | mediaFolderUpdateResponse422 | mediaFolderUpdateResponse500) & {
  headers: Headers;
};

export type mediaFolderUpdateResponse = (mediaFolderUpdateResponseSuccess | mediaFolderUpdateResponseError)

export const getMediaFolderUpdateUrl = (folderId: string,) => {




  return `/media-folders/${folderId}`
}

/**
 * Папку нельзя положить в саму себя или в свою вложенную — 422.
 * @summary Переименовать или переложить папку
 */
export const mediaFolderUpdate = async (folderId: string,
    updateFolderInputBody: NonReadonly<UpdateFolderInputBody>,
    headers: MediaFolderUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaFolderUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaFolderUpdateResponse>(getMediaFolderUpdateUrl(folderId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFolderInputBody)
  }
);}





export const getMediaFolderUpdateQueryKey = (folderId: string,
    updateFolderInputBody?: NonReadonly<UpdateFolderInputBody>,) => {
    return [
    'PATCH', `/media-folders/${folderId}`, updateFolderInputBody
    ] as const;
    }


export const getMediaFolderUpdateQueryOptions = <TData = Awaited<ReturnType<typeof mediaFolderUpdate>>, TError = ErrorModel>(folderId: string,
    updateFolderInputBody: NonReadonly<UpdateFolderInputBody>,
    headers: MediaFolderUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaFolderUpdateQueryKey(folderId,updateFolderInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaFolderUpdate>>> = ({ signal }) => mediaFolderUpdate(folderId,updateFolderInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: folderId !== null && folderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaFolderUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaFolderUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof mediaFolderUpdate>>>
export type MediaFolderUpdateQueryError = ErrorModel


export function useMediaFolderUpdate<TData = Awaited<ReturnType<typeof mediaFolderUpdate>>, TError = ErrorModel>(
 folderId: string,
    updateFolderInputBody: NonReadonly<UpdateFolderInputBody>,
    headers: MediaFolderUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderUpdate>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderUpdate<TData = Awaited<ReturnType<typeof mediaFolderUpdate>>, TError = ErrorModel>(
 folderId: string,
    updateFolderInputBody: NonReadonly<UpdateFolderInputBody>,
    headers: MediaFolderUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderUpdate>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderUpdate<TData = Awaited<ReturnType<typeof mediaFolderUpdate>>, TError = ErrorModel>(
 folderId: string,
    updateFolderInputBody: NonReadonly<UpdateFolderInputBody>,
    headers: MediaFolderUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Переименовать или переложить папку
 */

export function useMediaFolderUpdate<TData = Awaited<ReturnType<typeof mediaFolderUpdate>>, TError = ErrorModel>(
 folderId: string,
    updateFolderInputBody: NonReadonly<UpdateFolderInputBody>,
    headers: MediaFolderUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaFolderUpdateQueryOptions(folderId,updateFolderInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaFolderContentsResponse200 = {
  data: ContentsOutputBody
  status: 200
}

export type mediaFolderContentsResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaFolderContentsResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaFolderContentsResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaFolderContentsResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaFolderContentsResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaFolderContentsResponseSuccess = (mediaFolderContentsResponse200) & {
  headers: Headers;
};
export type mediaFolderContentsResponseError = (mediaFolderContentsResponse401 | mediaFolderContentsResponse403 | mediaFolderContentsResponse404 | mediaFolderContentsResponse422 | mediaFolderContentsResponse500) & {
  headers: Headers;
};

export type mediaFolderContentsResponse = (mediaFolderContentsResponseSuccess | mediaFolderContentsResponseError)

export const getMediaFolderContentsUrl = (folderId: string,) => {




  return `/media-folders/${folderId}/contents`
}

/**
 * @summary Что внутри папки — до удаления
 */
export const mediaFolderContents = async (folderId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaFolderContentsResponse> => {

  return facetaFetch<mediaFolderContentsResponse>(getMediaFolderContentsUrl(folderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaFolderContentsQueryKey = (folderId: string,) => {
    return [
    `/media-folders/${folderId}/contents`
    ] as const;
    }


export const getMediaFolderContentsQueryOptions = <TData = Awaited<ReturnType<typeof mediaFolderContents>>, TError = ErrorModel>(folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderContents>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaFolderContentsQueryKey(folderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaFolderContents>>> = ({ signal }) => mediaFolderContents(folderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: folderId !== null && folderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaFolderContents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaFolderContentsQueryResult = NonNullable<Awaited<ReturnType<typeof mediaFolderContents>>>
export type MediaFolderContentsQueryError = ErrorModel


export function useMediaFolderContents<TData = Awaited<ReturnType<typeof mediaFolderContents>>, TError = ErrorModel>(
 folderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderContents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderContents>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderContents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderContents<TData = Awaited<ReturnType<typeof mediaFolderContents>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderContents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderContents>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderContents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderContents<TData = Awaited<ReturnType<typeof mediaFolderContents>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderContents>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Что внутри папки — до удаления
 */

export function useMediaFolderContents<TData = Awaited<ReturnType<typeof mediaFolderContents>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderContents>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaFolderContentsQueryOptions(folderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaFolderRestoreResponse200 = {
  data: FolderBody
  status: 200
}

export type mediaFolderRestoreResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaFolderRestoreResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaFolderRestoreResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaFolderRestoreResponse409 = {
  data: ErrorModel
  status: 409
}

export type mediaFolderRestoreResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaFolderRestoreResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaFolderRestoreResponseSuccess = (mediaFolderRestoreResponse200) & {
  headers: Headers;
};
export type mediaFolderRestoreResponseError = (mediaFolderRestoreResponse401 | mediaFolderRestoreResponse403 | mediaFolderRestoreResponse404 | mediaFolderRestoreResponse409 | mediaFolderRestoreResponse422 | mediaFolderRestoreResponse500) & {
  headers: Headers;
};

export type mediaFolderRestoreResponse = (mediaFolderRestoreResponseSuccess | mediaFolderRestoreResponseError)

export const getMediaFolderRestoreUrl = (folderId: string,) => {




  return `/media-folders/${folderId}/restore`
}

/**
 * @summary Вернуть папку с тем, что ушло вместе с ней
 */
export const mediaFolderRestore = async (folderId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaFolderRestoreResponse> => {

  return facetaFetch<mediaFolderRestoreResponse>(getMediaFolderRestoreUrl(folderId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMediaFolderRestoreQueryKey = (folderId: string,) => {
    return [
    'POST', `/media-folders/${folderId}/restore`
    ] as const;
    }


export const getMediaFolderRestoreQueryOptions = <TData = Awaited<ReturnType<typeof mediaFolderRestore>>, TError = ErrorModel>(folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaFolderRestoreQueryKey(folderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaFolderRestore>>> = ({ signal }) => mediaFolderRestore(folderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: folderId !== null && folderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaFolderRestore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaFolderRestoreQueryResult = NonNullable<Awaited<ReturnType<typeof mediaFolderRestore>>>
export type MediaFolderRestoreQueryError = ErrorModel


export function useMediaFolderRestore<TData = Awaited<ReturnType<typeof mediaFolderRestore>>, TError = ErrorModel>(
 folderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderRestore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderRestore>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderRestore<TData = Awaited<ReturnType<typeof mediaFolderRestore>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderRestore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderRestore>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderRestore<TData = Awaited<ReturnType<typeof mediaFolderRestore>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вернуть папку с тем, что ушло вместе с ней
 */

export function useMediaFolderRestore<TData = Awaited<ReturnType<typeof mediaFolderRestore>>, TError = ErrorModel>(
 folderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaFolderRestoreQueryOptions(folderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaDeleteResponse204 = {
  data: void
  status: 204
}

export type mediaDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaDeleteResponseSuccess = (mediaDeleteResponse204) & {
  headers: Headers;
};
export type mediaDeleteResponseError = (mediaDeleteResponse401 | mediaDeleteResponse403 | mediaDeleteResponse404 | mediaDeleteResponse422 | mediaDeleteResponse500) & {
  headers: Headers;
};

export type mediaDeleteResponse = (mediaDeleteResponseSuccess | mediaDeleteResponseError)

export const getMediaDeleteUrl = (mediaId: string,) => {




  return `/media/${mediaId}`
}

/**
 * Из хранилища файл не удаляется: на него могут ссылаться уже опубликованные записи.
 * @summary Убрать файл в корзину
 */
export const mediaDelete = async (mediaId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaDeleteResponse> => {

  return facetaFetch<mediaDeleteResponse>(getMediaDeleteUrl(mediaId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMediaDeleteQueryKey = (mediaId: string,) => {
    return [
    'DELETE', `/media/${mediaId}`
    ] as const;
    }


export const getMediaDeleteQueryOptions = <TData = Awaited<ReturnType<typeof mediaDelete>>, TError = ErrorModel>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaDeleteQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaDelete>>> = ({ signal }) => mediaDelete(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof mediaDelete>>>
export type MediaDeleteQueryError = ErrorModel


export function useMediaDelete<TData = Awaited<ReturnType<typeof mediaDelete>>, TError = ErrorModel>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaDelete>>,
          TError,
          Awaited<ReturnType<typeof mediaDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaDelete<TData = Awaited<ReturnType<typeof mediaDelete>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaDelete>>,
          TError,
          Awaited<ReturnType<typeof mediaDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaDelete<TData = Awaited<ReturnType<typeof mediaDelete>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Убрать файл в корзину
 */

export function useMediaDelete<TData = Awaited<ReturnType<typeof mediaDelete>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaDeleteQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaGetResponse200 = {
  data: AssetBody
  status: 200
}

export type mediaGetResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaGetResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaGetResponseSuccess = (mediaGetResponse200) & {
  headers: Headers;
};
export type mediaGetResponseError = (mediaGetResponse401 | mediaGetResponse403 | mediaGetResponse404 | mediaGetResponse422 | mediaGetResponse500) & {
  headers: Headers;
};

export type mediaGetResponse = (mediaGetResponseSuccess | mediaGetResponseError)

export const getMediaGetUrl = (mediaId: string,) => {




  return `/media/${mediaId}`
}

/**
 * @summary Файл
 */
export const mediaGet = async (mediaId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaGetResponse> => {

  return facetaFetch<mediaGetResponse>(getMediaGetUrl(mediaId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaGetQueryKey = (mediaId: string,) => {
    return [
    `/media/${mediaId}`
    ] as const;
    }


export const getMediaGetQueryOptions = <TData = Awaited<ReturnType<typeof mediaGet>>, TError = ErrorModel>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaGetQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaGet>>> = ({ signal }) => mediaGet(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaGetQueryResult = NonNullable<Awaited<ReturnType<typeof mediaGet>>>
export type MediaGetQueryError = ErrorModel


export function useMediaGet<TData = Awaited<ReturnType<typeof mediaGet>>, TError = ErrorModel>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaGet>>,
          TError,
          Awaited<ReturnType<typeof mediaGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaGet<TData = Awaited<ReturnType<typeof mediaGet>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaGet>>,
          TError,
          Awaited<ReturnType<typeof mediaGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaGet<TData = Awaited<ReturnType<typeof mediaGet>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Файл
 */

export function useMediaGet<TData = Awaited<ReturnType<typeof mediaGet>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaGetQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaUpdateResponse200 = {
  data: AssetBody
  status: 200
}

export type mediaUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaUpdateResponseSuccess = (mediaUpdateResponse200) & {
  headers: Headers;
};
export type mediaUpdateResponseError = (mediaUpdateResponse401 | mediaUpdateResponse403 | mediaUpdateResponse404 | mediaUpdateResponse422 | mediaUpdateResponse500) & {
  headers: Headers;
};

export type mediaUpdateResponse = (mediaUpdateResponseSuccess | mediaUpdateResponseError)

export const getMediaUpdateUrl = (mediaId: string,) => {




  return `/media/${mediaId}`
}

/**
 * Имя, подпись, точка фокуса, постер, папка. Содержимое не заменяется: замена файла под тем же идентификатором поменяла бы его во всех записях разом, а человек, меняющий картинку в одной статье, этого не ожидает.
 * @summary Поменять сведения о файле
 */
export const mediaUpdate = async (mediaId: string,
    updateInputBody2: NonReadonly<UpdateInputBody2>,
    headers: MediaUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaUpdateResponse>(getMediaUpdateUrl(mediaId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateInputBody2)
  }
);}





export const getMediaUpdateQueryKey = (mediaId: string,
    updateInputBody2?: NonReadonly<UpdateInputBody2>,) => {
    return [
    'PATCH', `/media/${mediaId}`, updateInputBody2
    ] as const;
    }


export const getMediaUpdateQueryOptions = <TData = Awaited<ReturnType<typeof mediaUpdate>>, TError = ErrorModel>(mediaId: string,
    updateInputBody2: NonReadonly<UpdateInputBody2>,
    headers: MediaUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaUpdateQueryKey(mediaId,updateInputBody2);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaUpdate>>> = ({ signal }) => mediaUpdate(mediaId,updateInputBody2,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof mediaUpdate>>>
export type MediaUpdateQueryError = ErrorModel


export function useMediaUpdate<TData = Awaited<ReturnType<typeof mediaUpdate>>, TError = ErrorModel>(
 mediaId: string,
    updateInputBody2: NonReadonly<UpdateInputBody2>,
    headers: MediaUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUpdate>>,
          TError,
          Awaited<ReturnType<typeof mediaUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUpdate<TData = Awaited<ReturnType<typeof mediaUpdate>>, TError = ErrorModel>(
 mediaId: string,
    updateInputBody2: NonReadonly<UpdateInputBody2>,
    headers: MediaUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUpdate>>,
          TError,
          Awaited<ReturnType<typeof mediaUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUpdate<TData = Awaited<ReturnType<typeof mediaUpdate>>, TError = ErrorModel>(
 mediaId: string,
    updateInputBody2: NonReadonly<UpdateInputBody2>,
    headers: MediaUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Поменять сведения о файле
 */

export function useMediaUpdate<TData = Awaited<ReturnType<typeof mediaUpdate>>, TError = ErrorModel>(
 mediaId: string,
    updateInputBody2: NonReadonly<UpdateInputBody2>,
    headers: MediaUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaUpdateQueryOptions(mediaId,updateInputBody2,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaFileResponse200 = {
  data: void
  status: 200
}

export type mediaFileResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaFileResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaFileResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaFileResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaFileResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaFileResponseSuccess = (mediaFileResponse200) & {
  headers: Headers;
};
export type mediaFileResponseError = (mediaFileResponse401 | mediaFileResponse403 | mediaFileResponse404 | mediaFileResponse422 | mediaFileResponse500) & {
  headers: Headers;
};

export type mediaFileResponse = (mediaFileResponseSuccess | mediaFileResponseError)

export const getMediaFileUrl = (mediaId: string,) => {




  return `/media/${mediaId}/file`
}

/**
 * С перемоткой (Range): видео отдаётся кусками по мере просмотра, а не целиком. Медиатека не публична — показ файлов посетителям сайта решается в API для сайтов.
 * @summary Содержимое файла
 */
export const mediaFile = async (mediaId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaFileResponse> => {

  return facetaFetch<mediaFileResponse>(getMediaFileUrl(mediaId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaFileQueryKey = (mediaId: string,) => {
    return [
    `/media/${mediaId}/file`
    ] as const;
    }


export const getMediaFileQueryOptions = <TData = Awaited<ReturnType<typeof mediaFile>>, TError = ErrorModel>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFile>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaFileQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaFile>>> = ({ signal }) => mediaFile(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaFileQueryResult = NonNullable<Awaited<ReturnType<typeof mediaFile>>>
export type MediaFileQueryError = ErrorModel


export function useMediaFile<TData = Awaited<ReturnType<typeof mediaFile>>, TError = ErrorModel>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFile>>,
          TError,
          Awaited<ReturnType<typeof mediaFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFile<TData = Awaited<ReturnType<typeof mediaFile>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFile>>,
          TError,
          Awaited<ReturnType<typeof mediaFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFile<TData = Awaited<ReturnType<typeof mediaFile>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFile>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Содержимое файла
 */

export function useMediaFile<TData = Awaited<ReturnType<typeof mediaFile>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFile>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaFileQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaFrameResponse200 = {
  data: void
  status: 200
}

export type mediaFrameResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaFrameResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaFrameResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaFrameResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaFrameResponseSuccess = (mediaFrameResponse200) & {
  headers: Headers;
};
export type mediaFrameResponseError = (mediaFrameResponse403 | mediaFrameResponse404 | mediaFrameResponse422 | mediaFrameResponse500) & {
  headers: Headers;
};

export type mediaFrameResponse = (mediaFrameResponseSuccess | mediaFrameResponseError)

export const getMediaFrameUrl = (mediaId: string,
    params?: MediaFrameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/media/${mediaId}/frame?${stringifiedParams}` : `/media/${mediaId}/frame`
}

/**
 * JPEG — для раскадровки при выборе постера. Ссылку выдаёт mediaPlayback.
 * @summary Кадр видео по подписанной ссылке
 */
export const mediaFrame = async (mediaId: string,
    params?: MediaFrameParams, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaFrameResponse> => {

  return facetaFetch<mediaFrameResponse>(getMediaFrameUrl(mediaId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaFrameQueryKey = (mediaId: string,
    params?: MediaFrameParams,) => {
    return [
    `/media/${mediaId}/frame`, ...(params ? [params] : [])
    ] as const;
    }


export const getMediaFrameQueryOptions = <TData = Awaited<ReturnType<typeof mediaFrame>>, TError = ErrorModel>(mediaId: string,
    params?: MediaFrameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFrame>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaFrameQueryKey(mediaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaFrame>>> = ({ signal }) => mediaFrame(mediaId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaFrame>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaFrameQueryResult = NonNullable<Awaited<ReturnType<typeof mediaFrame>>>
export type MediaFrameQueryError = ErrorModel


export function useMediaFrame<TData = Awaited<ReturnType<typeof mediaFrame>>, TError = ErrorModel>(
 mediaId: string,
    params: undefined |  MediaFrameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFrame>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFrame>>,
          TError,
          Awaited<ReturnType<typeof mediaFrame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFrame<TData = Awaited<ReturnType<typeof mediaFrame>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaFrameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFrame>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFrame>>,
          TError,
          Awaited<ReturnType<typeof mediaFrame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFrame<TData = Awaited<ReturnType<typeof mediaFrame>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaFrameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFrame>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Кадр видео по подписанной ссылке
 */

export function useMediaFrame<TData = Awaited<ReturnType<typeof mediaFrame>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaFrameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFrame>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaFrameQueryOptions(mediaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaRequeueHLSResponse200 = {
  data: AssetBody
  status: 200
}

export type mediaRequeueHLSResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaRequeueHLSResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaRequeueHLSResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaRequeueHLSResponse409 = {
  data: ErrorModel
  status: 409
}

export type mediaRequeueHLSResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaRequeueHLSResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaRequeueHLSResponseSuccess = (mediaRequeueHLSResponse200) & {
  headers: Headers;
};
export type mediaRequeueHLSResponseError = (mediaRequeueHLSResponse401 | mediaRequeueHLSResponse403 | mediaRequeueHLSResponse404 | mediaRequeueHLSResponse409 | mediaRequeueHLSResponse422 | mediaRequeueHLSResponse500) & {
  headers: Headers;
};

export type mediaRequeueHLSResponse = (mediaRequeueHLSResponseSuccess | mediaRequeueHLSResponseError)

export const getMediaRequeueHLSUrl = (mediaId: string,) => {




  return `/media/${mediaId}/hls`
}

/**
 * @summary Перекодировать видео в HLS ещё раз
 */
export const mediaRequeueHLS = async (mediaId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaRequeueHLSResponse> => {

  return facetaFetch<mediaRequeueHLSResponse>(getMediaRequeueHLSUrl(mediaId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMediaRequeueHLSQueryKey = (mediaId: string,) => {
    return [
    'POST', `/media/${mediaId}/hls`
    ] as const;
    }


export const getMediaRequeueHLSQueryOptions = <TData = Awaited<ReturnType<typeof mediaRequeueHLS>>, TError = ErrorModel>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRequeueHLS>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaRequeueHLSQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaRequeueHLS>>> = ({ signal }) => mediaRequeueHLS(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaRequeueHLS>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaRequeueHLSQueryResult = NonNullable<Awaited<ReturnType<typeof mediaRequeueHLS>>>
export type MediaRequeueHLSQueryError = ErrorModel


export function useMediaRequeueHLS<TData = Awaited<ReturnType<typeof mediaRequeueHLS>>, TError = ErrorModel>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRequeueHLS>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaRequeueHLS>>,
          TError,
          Awaited<ReturnType<typeof mediaRequeueHLS>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaRequeueHLS<TData = Awaited<ReturnType<typeof mediaRequeueHLS>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRequeueHLS>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaRequeueHLS>>,
          TError,
          Awaited<ReturnType<typeof mediaRequeueHLS>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaRequeueHLS<TData = Awaited<ReturnType<typeof mediaRequeueHLS>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRequeueHLS>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Перекодировать видео в HLS ещё раз
 */

export function useMediaRequeueHLS<TData = Awaited<ReturnType<typeof mediaRequeueHLS>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRequeueHLS>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaRequeueHLSQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaPlaybackResponse200 = {
  data: PlaybackOutputBody
  status: 200
}

export type mediaPlaybackResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaPlaybackResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaPlaybackResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaPlaybackResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaPlaybackResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaPlaybackResponseSuccess = (mediaPlaybackResponse200) & {
  headers: Headers;
};
export type mediaPlaybackResponseError = (mediaPlaybackResponse401 | mediaPlaybackResponse403 | mediaPlaybackResponse404 | mediaPlaybackResponse422 | mediaPlaybackResponse500) & {
  headers: Headers;
};

export type mediaPlaybackResponse = (mediaPlaybackResponseSuccess | mediaPlaybackResponseError)

export const getMediaPlaybackUrl = (mediaId: string,) => {




  return `/media/${mediaId}/playback`
}

/**
 * Подписанные ссылки на файл и на кадры видео — для тегов <video> и <img>, которые не умеют посылать токен. Действуют несколько часов и только для этого файла.
 * @summary Ссылки на просмотр файла
 */
export const mediaPlayback = async (mediaId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaPlaybackResponse> => {

  return facetaFetch<mediaPlaybackResponse>(getMediaPlaybackUrl(mediaId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaPlaybackQueryKey = (mediaId: string,) => {
    return [
    `/media/${mediaId}/playback`
    ] as const;
    }


export const getMediaPlaybackQueryOptions = <TData = Awaited<ReturnType<typeof mediaPlayback>>, TError = ErrorModel>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPlayback>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaPlaybackQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaPlayback>>> = ({ signal }) => mediaPlayback(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaPlayback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaPlaybackQueryResult = NonNullable<Awaited<ReturnType<typeof mediaPlayback>>>
export type MediaPlaybackQueryError = ErrorModel


export function useMediaPlayback<TData = Awaited<ReturnType<typeof mediaPlayback>>, TError = ErrorModel>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPlayback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaPlayback>>,
          TError,
          Awaited<ReturnType<typeof mediaPlayback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaPlayback<TData = Awaited<ReturnType<typeof mediaPlayback>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPlayback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaPlayback>>,
          TError,
          Awaited<ReturnType<typeof mediaPlayback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaPlayback<TData = Awaited<ReturnType<typeof mediaPlayback>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPlayback>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ссылки на просмотр файла
 */

export function useMediaPlayback<TData = Awaited<ReturnType<typeof mediaPlayback>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPlayback>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaPlaybackQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaPosterFromFrameResponse200 = {
  data: PosterFrameOutputBody
  status: 200
}

export type mediaPosterFromFrameResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaPosterFromFrameResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaPosterFromFrameResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaPosterFromFrameResponse412 = {
  data: ErrorModel
  status: 412
}

export type mediaPosterFromFrameResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaPosterFromFrameResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaPosterFromFrameResponseSuccess = (mediaPosterFromFrameResponse200) & {
  headers: Headers;
};
export type mediaPosterFromFrameResponseError = (mediaPosterFromFrameResponse401 | mediaPosterFromFrameResponse403 | mediaPosterFromFrameResponse404 | mediaPosterFromFrameResponse412 | mediaPosterFromFrameResponse422 | mediaPosterFromFrameResponse500) & {
  headers: Headers;
};

export type mediaPosterFromFrameResponse = (mediaPosterFromFrameResponseSuccess | mediaPosterFromFrameResponseError)

export const getMediaPosterFromFrameUrl = (mediaId: string,) => {




  return `/media/${mediaId}/poster-frame`
}

/**
 * Кадр в полном размере сохраняется картинкой в ту же папку медиатеки (сжатой по настройкам сайта) и становится постером видео.
 * @summary Постер из кадра видео
 */
export const mediaPosterFromFrame = async (mediaId: string,
    posterFrameInputBody: NonReadonly<PosterFrameInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaPosterFromFrameResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaPosterFromFrameResponse>(getMediaPosterFromFrameUrl(mediaId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(posterFrameInputBody)
  }
);}





export const getMediaPosterFromFrameQueryKey = (mediaId: string,
    posterFrameInputBody?: NonReadonly<PosterFrameInputBody>,) => {
    return [
    'POST', `/media/${mediaId}/poster-frame`, posterFrameInputBody
    ] as const;
    }


export const getMediaPosterFromFrameQueryOptions = <TData = Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError = ErrorModel>(mediaId: string,
    posterFrameInputBody: NonReadonly<PosterFrameInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaPosterFromFrameQueryKey(mediaId,posterFrameInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaPosterFromFrame>>> = ({ signal }) => mediaPosterFromFrame(mediaId,posterFrameInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaPosterFromFrameQueryResult = NonNullable<Awaited<ReturnType<typeof mediaPosterFromFrame>>>
export type MediaPosterFromFrameQueryError = ErrorModel


export function useMediaPosterFromFrame<TData = Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError = ErrorModel>(
 mediaId: string,
    posterFrameInputBody: NonReadonly<PosterFrameInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaPosterFromFrame>>,
          TError,
          Awaited<ReturnType<typeof mediaPosterFromFrame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaPosterFromFrame<TData = Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError = ErrorModel>(
 mediaId: string,
    posterFrameInputBody: NonReadonly<PosterFrameInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaPosterFromFrame>>,
          TError,
          Awaited<ReturnType<typeof mediaPosterFromFrame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaPosterFromFrame<TData = Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError = ErrorModel>(
 mediaId: string,
    posterFrameInputBody: NonReadonly<PosterFrameInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Постер из кадра видео
 */

export function useMediaPosterFromFrame<TData = Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError = ErrorModel>(
 mediaId: string,
    posterFrameInputBody: NonReadonly<PosterFrameInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPosterFromFrame>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaPosterFromFrameQueryOptions(mediaId,posterFrameInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaPreviewResponse200 = {
  data: void
  status: 200
}

export type mediaPreviewResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaPreviewResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaPreviewResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaPreviewResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaPreviewResponseSuccess = (mediaPreviewResponse200) & {
  headers: Headers;
};
export type mediaPreviewResponseError = (mediaPreviewResponse403 | mediaPreviewResponse404 | mediaPreviewResponse422 | mediaPreviewResponse500) & {
  headers: Headers;
};

export type mediaPreviewResponse = (mediaPreviewResponseSuccess | mediaPreviewResponseError)

export const getMediaPreviewUrl = (mediaId: string,
    params?: MediaPreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/media/${mediaId}/preview?${stringifiedParams}` : `/media/${mediaId}/preview`
}

/**
 * Адрес приходит готовым в thumb_url файла: <img> берёт его без токена, а браузер держит в кеше — сетка медиатеки открывается сразу.
 * @summary Превью по подписанной ссылке
 */
export const mediaPreview = async (mediaId: string,
    params?: MediaPreviewParams, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaPreviewResponse> => {

  return facetaFetch<mediaPreviewResponse>(getMediaPreviewUrl(mediaId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaPreviewQueryKey = (mediaId: string,
    params?: MediaPreviewParams,) => {
    return [
    `/media/${mediaId}/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getMediaPreviewQueryOptions = <TData = Awaited<ReturnType<typeof mediaPreview>>, TError = ErrorModel>(mediaId: string,
    params?: MediaPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaPreviewQueryKey(mediaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaPreview>>> = ({ signal }) => mediaPreview(mediaId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof mediaPreview>>>
export type MediaPreviewQueryError = ErrorModel


export function useMediaPreview<TData = Awaited<ReturnType<typeof mediaPreview>>, TError = ErrorModel>(
 mediaId: string,
    params: undefined |  MediaPreviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaPreview>>,
          TError,
          Awaited<ReturnType<typeof mediaPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaPreview<TData = Awaited<ReturnType<typeof mediaPreview>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaPreview>>,
          TError,
          Awaited<ReturnType<typeof mediaPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaPreview<TData = Awaited<ReturnType<typeof mediaPreview>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Превью по подписанной ссылке
 */

export function useMediaPreview<TData = Awaited<ReturnType<typeof mediaPreview>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaPreviewQueryOptions(mediaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaReplaceResponse200 = {
  data: AssetBody
  status: 200
}

export type mediaReplaceResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaReplaceResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaReplaceResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaReplaceResponse413 = {
  data: ErrorModel
  status: 413
}

export type mediaReplaceResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaReplaceResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaReplaceResponseSuccess = (mediaReplaceResponse200) & {
  headers: Headers;
};
export type mediaReplaceResponseError = (mediaReplaceResponse401 | mediaReplaceResponse403 | mediaReplaceResponse404 | mediaReplaceResponse413 | mediaReplaceResponse422 | mediaReplaceResponse500) & {
  headers: Headers;
};

export type mediaReplaceResponse = (mediaReplaceResponseSuccess | mediaReplaceResponseError)

export const getMediaReplaceUrl = (mediaId: string,) => {




  return `/media/${mediaId}/replace`
}

/**
 * Новое содержимое под тем же id: меняется во всех записях, где файл стоит, и на сайте. Вид файла должен совпадать — картинку меняют на картинку. Имя, подпись, папка, точка фокуса и постер остаются. Больше 50 МБ — загрузкой частями с replace_id.
 * @summary Заменить файл
 */
export const mediaReplace = async (mediaId: string,
    mediaReplaceBody?: MediaReplaceBody, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaReplaceResponse> => {
    const formData = new FormData();
if(mediaReplaceBody?.file !== undefined) {
 formData.append(`file`, mediaReplaceBody.file);
 }

  return facetaFetch<mediaReplaceResponse>(getMediaReplaceUrl(mediaId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getMediaReplaceQueryKey = (mediaId: string,
    mediaReplaceBody?: MediaReplaceBody,) => {
    return [
    'POST', `/media/${mediaId}/replace`, mediaReplaceBody
    ] as const;
    }


export const getMediaReplaceQueryOptions = <TData = Awaited<ReturnType<typeof mediaReplace>>, TError = ErrorModel>(mediaId: string,
    mediaReplaceBody?: MediaReplaceBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaReplace>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaReplaceQueryKey(mediaId,mediaReplaceBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaReplace>>> = ({ signal }) => mediaReplace(mediaId,mediaReplaceBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaReplace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaReplaceQueryResult = NonNullable<Awaited<ReturnType<typeof mediaReplace>>>
export type MediaReplaceQueryError = ErrorModel


export function useMediaReplace<TData = Awaited<ReturnType<typeof mediaReplace>>, TError = ErrorModel>(
 mediaId: string,
    mediaReplaceBody: undefined |  MediaReplaceBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaReplace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaReplace>>,
          TError,
          Awaited<ReturnType<typeof mediaReplace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaReplace<TData = Awaited<ReturnType<typeof mediaReplace>>, TError = ErrorModel>(
 mediaId: string,
    mediaReplaceBody?: MediaReplaceBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaReplace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaReplace>>,
          TError,
          Awaited<ReturnType<typeof mediaReplace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaReplace<TData = Awaited<ReturnType<typeof mediaReplace>>, TError = ErrorModel>(
 mediaId: string,
    mediaReplaceBody?: MediaReplaceBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaReplace>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Заменить файл
 */

export function useMediaReplace<TData = Awaited<ReturnType<typeof mediaReplace>>, TError = ErrorModel>(
 mediaId: string,
    mediaReplaceBody?: MediaReplaceBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaReplace>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaReplaceQueryOptions(mediaId,mediaReplaceBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaRestoreResponse200 = {
  data: AssetBody
  status: 200
}

export type mediaRestoreResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaRestoreResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaRestoreResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaRestoreResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaRestoreResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaRestoreResponseSuccess = (mediaRestoreResponse200) & {
  headers: Headers;
};
export type mediaRestoreResponseError = (mediaRestoreResponse401 | mediaRestoreResponse403 | mediaRestoreResponse404 | mediaRestoreResponse422 | mediaRestoreResponse500) & {
  headers: Headers;
};

export type mediaRestoreResponse = (mediaRestoreResponseSuccess | mediaRestoreResponseError)

export const getMediaRestoreUrl = (mediaId: string,) => {




  return `/media/${mediaId}/restore`
}

/**
 * @summary Вернуть файл из корзины
 */
export const mediaRestore = async (mediaId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaRestoreResponse> => {

  return facetaFetch<mediaRestoreResponse>(getMediaRestoreUrl(mediaId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMediaRestoreQueryKey = (mediaId: string,) => {
    return [
    'POST', `/media/${mediaId}/restore`
    ] as const;
    }


export const getMediaRestoreQueryOptions = <TData = Awaited<ReturnType<typeof mediaRestore>>, TError = ErrorModel>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaRestoreQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaRestore>>> = ({ signal }) => mediaRestore(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaRestore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaRestoreQueryResult = NonNullable<Awaited<ReturnType<typeof mediaRestore>>>
export type MediaRestoreQueryError = ErrorModel


export function useMediaRestore<TData = Awaited<ReturnType<typeof mediaRestore>>, TError = ErrorModel>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaRestore>>,
          TError,
          Awaited<ReturnType<typeof mediaRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaRestore<TData = Awaited<ReturnType<typeof mediaRestore>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaRestore>>,
          TError,
          Awaited<ReturnType<typeof mediaRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaRestore<TData = Awaited<ReturnType<typeof mediaRestore>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вернуть файл из корзины
 */

export function useMediaRestore<TData = Awaited<ReturnType<typeof mediaRestore>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaRestoreQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaStreamResponse200 = {
  data: void
  status: 200
}

export type mediaStreamResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaStreamResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaStreamResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaStreamResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaStreamResponseSuccess = (mediaStreamResponse200) & {
  headers: Headers;
};
export type mediaStreamResponseError = (mediaStreamResponse403 | mediaStreamResponse404 | mediaStreamResponse422 | mediaStreamResponse500) & {
  headers: Headers;
};

export type mediaStreamResponse = (mediaStreamResponseSuccess | mediaStreamResponseError)

export const getMediaStreamUrl = (mediaId: string,
    params?: MediaStreamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/media/${mediaId}/stream?${stringifiedParams}` : `/media/${mediaId}/stream`
}

/**
 * С перемоткой (Range). Ссылку выдаёт mediaPlayback.
 * @summary Файл по подписанной ссылке
 */
export const mediaStream = async (mediaId: string,
    params?: MediaStreamParams, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaStreamResponse> => {

  return facetaFetch<mediaStreamResponse>(getMediaStreamUrl(mediaId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaStreamQueryKey = (mediaId: string,
    params?: MediaStreamParams,) => {
    return [
    `/media/${mediaId}/stream`, ...(params ? [params] : [])
    ] as const;
    }


export const getMediaStreamQueryOptions = <TData = Awaited<ReturnType<typeof mediaStream>>, TError = ErrorModel>(mediaId: string,
    params?: MediaStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaStream>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaStreamQueryKey(mediaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaStream>>> = ({ signal }) => mediaStream(mediaId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaStreamQueryResult = NonNullable<Awaited<ReturnType<typeof mediaStream>>>
export type MediaStreamQueryError = ErrorModel


export function useMediaStream<TData = Awaited<ReturnType<typeof mediaStream>>, TError = ErrorModel>(
 mediaId: string,
    params: undefined |  MediaStreamParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaStream>>,
          TError,
          Awaited<ReturnType<typeof mediaStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaStream<TData = Awaited<ReturnType<typeof mediaStream>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaStream>>,
          TError,
          Awaited<ReturnType<typeof mediaStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaStream<TData = Awaited<ReturnType<typeof mediaStream>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaStream>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Файл по подписанной ссылке
 */

export function useMediaStream<TData = Awaited<ReturnType<typeof mediaStream>>, TError = ErrorModel>(
 mediaId: string,
    params?: MediaStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaStream>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaStreamQueryOptions(mediaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaThumbResponse200 = {
  data: void
  status: 200
}

export type mediaThumbResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaThumbResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaThumbResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaThumbResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaThumbResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaThumbResponseSuccess = (mediaThumbResponse200) & {
  headers: Headers;
};
export type mediaThumbResponseError = (mediaThumbResponse401 | mediaThumbResponse403 | mediaThumbResponse404 | mediaThumbResponse422 | mediaThumbResponse500) & {
  headers: Headers;
};

export type mediaThumbResponse = (mediaThumbResponseSuccess | mediaThumbResponseError)

export const getMediaThumbUrl = (mediaId: string,) => {




  return `/media/${mediaId}/thumb`
}

/**
 * @summary Превью изображения
 */
export const mediaThumb = async (mediaId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaThumbResponse> => {

  return facetaFetch<mediaThumbResponse>(getMediaThumbUrl(mediaId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaThumbQueryKey = (mediaId: string,) => {
    return [
    `/media/${mediaId}/thumb`
    ] as const;
    }


export const getMediaThumbQueryOptions = <TData = Awaited<ReturnType<typeof mediaThumb>>, TError = ErrorModel>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaThumb>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaThumbQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaThumb>>> = ({ signal }) => mediaThumb(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaThumb>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaThumbQueryResult = NonNullable<Awaited<ReturnType<typeof mediaThumb>>>
export type MediaThumbQueryError = ErrorModel


export function useMediaThumb<TData = Awaited<ReturnType<typeof mediaThumb>>, TError = ErrorModel>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaThumb>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaThumb>>,
          TError,
          Awaited<ReturnType<typeof mediaThumb>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaThumb<TData = Awaited<ReturnType<typeof mediaThumb>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaThumb>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaThumb>>,
          TError,
          Awaited<ReturnType<typeof mediaThumb>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaThumb<TData = Awaited<ReturnType<typeof mediaThumb>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaThumb>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Превью изображения
 */

export function useMediaThumb<TData = Awaited<ReturnType<typeof mediaThumb>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaThumb>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaThumbQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaUsageResponse200 = {
  data: UsageOutputBody1
  status: 200
}

export type mediaUsageResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaUsageResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaUsageResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaUsageResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaUsageResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaUsageResponseSuccess = (mediaUsageResponse200) & {
  headers: Headers;
};
export type mediaUsageResponseError = (mediaUsageResponse401 | mediaUsageResponse403 | mediaUsageResponse404 | mediaUsageResponse422 | mediaUsageResponse500) & {
  headers: Headers;
};

export type mediaUsageResponse = (mediaUsageResponseSuccess | mediaUsageResponseError)

export const getMediaUsageUrl = (mediaId: string,) => {




  return `/media/${mediaId}/usage`
}

/**
 * Записи окружения, в значениях которых стоит файл — в поле, блоке, группе или переводе. Показывается до удаления: «стоит в 3 записях».
 * @summary Где стоит файл
 */
export const mediaUsage = async (mediaId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaUsageResponse> => {

  return facetaFetch<mediaUsageResponse>(getMediaUsageUrl(mediaId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaUsageQueryKey = (mediaId: string,) => {
    return [
    `/media/${mediaId}/usage`
    ] as const;
    }


export const getMediaUsageQueryOptions = <TData = Awaited<ReturnType<typeof mediaUsage>>, TError = ErrorModel>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUsage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaUsageQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaUsage>>> = ({ signal }) => mediaUsage(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: mediaId !== null && mediaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaUsageQueryResult = NonNullable<Awaited<ReturnType<typeof mediaUsage>>>
export type MediaUsageQueryError = ErrorModel


export function useMediaUsage<TData = Awaited<ReturnType<typeof mediaUsage>>, TError = ErrorModel>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUsage>>,
          TError,
          Awaited<ReturnType<typeof mediaUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUsage<TData = Awaited<ReturnType<typeof mediaUsage>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUsage>>,
          TError,
          Awaited<ReturnType<typeof mediaUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUsage<TData = Awaited<ReturnType<typeof mediaUsage>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUsage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Где стоит файл
 */

export function useMediaUsage<TData = Awaited<ReturnType<typeof mediaUsage>>, TError = ErrorModel>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUsage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaUsageQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaListResponse200 = {
  data: AssetListBody
  status: 200
}

export type mediaListResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaListResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaListResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaListResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaListResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaListResponseSuccess = (mediaListResponse200) & {
  headers: Headers;
};
export type mediaListResponseError = (mediaListResponse401 | mediaListResponse403 | mediaListResponse404 | mediaListResponse422 | mediaListResponse500) & {
  headers: Headers;
};

export type mediaListResponse = (mediaListResponseSuccess | mediaListResponseError)

export const getMediaListUrl = (id: string,
    kind: 'production' | 'development',
    params?: MediaListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/environments/${kind}/media?${stringifiedParams}` : `/sites/${id}/environments/${kind}/media`
}

/**
 * Файлы папки, корня или всей медиатеки; быстрые виды — по виду файла, неиспользуемые, корзина.
 * @summary Медиатека окружения
 */
export const mediaList = async (id: string,
    kind: 'production' | 'development',
    params?: MediaListParams, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaListResponse> => {

  return facetaFetch<mediaListResponse>(getMediaListUrl(id,kind,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaListQueryKey = (id: string,
    kind: 'production' | 'development',
    params?: MediaListParams,) => {
    return [
    `/sites/${id}/environments/${kind}/media`, ...(params ? [params] : [])
    ] as const;
    }


export const getMediaListQueryOptions = <TData = Awaited<ReturnType<typeof mediaList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    params?: MediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaListQueryKey(id,kind,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaList>>> = ({ signal }) => mediaList(id,kind,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaListQueryResult = NonNullable<Awaited<ReturnType<typeof mediaList>>>
export type MediaListQueryError = ErrorModel


export function useMediaList<TData = Awaited<ReturnType<typeof mediaList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params: undefined |  MediaListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaList>>,
          TError,
          Awaited<ReturnType<typeof mediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaList<TData = Awaited<ReturnType<typeof mediaList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaList>>,
          TError,
          Awaited<ReturnType<typeof mediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaList<TData = Awaited<ReturnType<typeof mediaList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Медиатека окружения
 */

export function useMediaList<TData = Awaited<ReturnType<typeof mediaList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaListQueryOptions(id,kind,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaUploadResponse201 = {
  data: AssetBody
  status: 201
}

export type mediaUploadResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaUploadResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaUploadResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaUploadResponse413 = {
  data: ErrorModel
  status: 413
}

export type mediaUploadResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaUploadResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaUploadResponseSuccess = (mediaUploadResponse201) & {
  headers: Headers;
};
export type mediaUploadResponseError = (mediaUploadResponse401 | mediaUploadResponse403 | mediaUploadResponse404 | mediaUploadResponse413 | mediaUploadResponse422 | mediaUploadResponse500) & {
  headers: Headers;
};

export type mediaUploadResponse = (mediaUploadResponseSuccess | mediaUploadResponseError)

export const getMediaUploadUrl = (id: string,
    kind: 'production' | 'development',
    params?: MediaUploadParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/environments/${kind}/media?${stringifiedParams}` : `/sites/${id}/environments/${kind}/media`
}

/**
 * До 20 МБ одним запросом; больше — частями (/uploads). Вид файла определяется по содержимому, а не по тому, что сказал браузер.
 * @summary Загрузить небольшой файл
 */
export const mediaUpload = async (id: string,
    kind: 'production' | 'development',
    mediaUploadBody?: MediaUploadBody,
    params?: MediaUploadParams, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaUploadResponse> => {
    const formData = new FormData();
if(mediaUploadBody?.file !== undefined) {
 formData.append(`file`, mediaUploadBody.file);
 }

  return facetaFetch<mediaUploadResponse>(getMediaUploadUrl(id,kind,params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getMediaUploadQueryKey = (id: string,
    kind: 'production' | 'development',
    mediaUploadBody?: MediaUploadBody,
    params?: MediaUploadParams,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/media`, ...(params ? [params] : []), mediaUploadBody
    ] as const;
    }


export const getMediaUploadQueryOptions = <TData = Awaited<ReturnType<typeof mediaUpload>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    mediaUploadBody?: MediaUploadBody,
    params?: MediaUploadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpload>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaUploadQueryKey(id,kind,mediaUploadBody,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaUpload>>> = ({ signal }) => mediaUpload(id,kind,mediaUploadBody,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaUpload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaUploadQueryResult = NonNullable<Awaited<ReturnType<typeof mediaUpload>>>
export type MediaUploadQueryError = ErrorModel


export function useMediaUpload<TData = Awaited<ReturnType<typeof mediaUpload>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    mediaUploadBody: undefined |  MediaUploadBody,
    params: undefined |  MediaUploadParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUpload>>,
          TError,
          Awaited<ReturnType<typeof mediaUpload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUpload<TData = Awaited<ReturnType<typeof mediaUpload>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    mediaUploadBody?: MediaUploadBody,
    params?: MediaUploadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUpload>>,
          TError,
          Awaited<ReturnType<typeof mediaUpload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUpload<TData = Awaited<ReturnType<typeof mediaUpload>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    mediaUploadBody?: MediaUploadBody,
    params?: MediaUploadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpload>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Загрузить небольшой файл
 */

export function useMediaUpload<TData = Awaited<ReturnType<typeof mediaUpload>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    mediaUploadBody?: MediaUploadBody,
    params?: MediaUploadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUpload>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaUploadQueryOptions(id,kind,mediaUploadBody,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaFoldersResponse200 = {
  data: FoldersOutputBody
  status: 200
}

export type mediaFoldersResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaFoldersResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaFoldersResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaFoldersResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaFoldersResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaFoldersResponseSuccess = (mediaFoldersResponse200) & {
  headers: Headers;
};
export type mediaFoldersResponseError = (mediaFoldersResponse401 | mediaFoldersResponse403 | mediaFoldersResponse404 | mediaFoldersResponse422 | mediaFoldersResponse500) & {
  headers: Headers;
};

export type mediaFoldersResponse = (mediaFoldersResponseSuccess | mediaFoldersResponseError)

export const getMediaFoldersUrl = (id: string,
    kind: 'production' | 'development',
    params?: MediaFoldersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/environments/${kind}/media-folders?${stringifiedParams}` : `/sites/${id}/environments/${kind}/media-folders`
}

/**
 * @summary Папки медиатеки
 */
export const mediaFolders = async (id: string,
    kind: 'production' | 'development',
    params?: MediaFoldersParams, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaFoldersResponse> => {

  return facetaFetch<mediaFoldersResponse>(getMediaFoldersUrl(id,kind,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaFoldersQueryKey = (id: string,
    kind: 'production' | 'development',
    params?: MediaFoldersParams,) => {
    return [
    `/sites/${id}/environments/${kind}/media-folders`, ...(params ? [params] : [])
    ] as const;
    }


export const getMediaFoldersQueryOptions = <TData = Awaited<ReturnType<typeof mediaFolders>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    params?: MediaFoldersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolders>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaFoldersQueryKey(id,kind,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaFolders>>> = ({ signal }) => mediaFolders(id,kind,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaFolders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof mediaFolders>>>
export type MediaFoldersQueryError = ErrorModel


export function useMediaFolders<TData = Awaited<ReturnType<typeof mediaFolders>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params: undefined |  MediaFoldersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolders>>,
          TError,
          Awaited<ReturnType<typeof mediaFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolders<TData = Awaited<ReturnType<typeof mediaFolders>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaFoldersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolders>>,
          TError,
          Awaited<ReturnType<typeof mediaFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolders<TData = Awaited<ReturnType<typeof mediaFolders>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaFoldersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolders>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Папки медиатеки
 */

export function useMediaFolders<TData = Awaited<ReturnType<typeof mediaFolders>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaFoldersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolders>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaFoldersQueryOptions(id,kind,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaFolderCreateResponse201 = {
  data: FolderBody
  status: 201
}

export type mediaFolderCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaFolderCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaFolderCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaFolderCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type mediaFolderCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaFolderCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaFolderCreateResponseSuccess = (mediaFolderCreateResponse201) & {
  headers: Headers;
};
export type mediaFolderCreateResponseError = (mediaFolderCreateResponse401 | mediaFolderCreateResponse403 | mediaFolderCreateResponse404 | mediaFolderCreateResponse409 | mediaFolderCreateResponse422 | mediaFolderCreateResponse500) & {
  headers: Headers;
};

export type mediaFolderCreateResponse = (mediaFolderCreateResponseSuccess | mediaFolderCreateResponseError)

export const getMediaFolderCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/media-folders`
}

/**
 * Одно имя на уровне: две «Обложки» рядом путают сильнее, чем помогают.
 * @summary Завести папку
 */
export const mediaFolderCreate = async (id: string,
    kind: 'production' | 'development',
    createFolderInputBody: NonReadonly<CreateFolderInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaFolderCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaFolderCreateResponse>(getMediaFolderCreateUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFolderInputBody)
  }
);}





export const getMediaFolderCreateQueryKey = (id: string,
    kind: 'production' | 'development',
    createFolderInputBody?: NonReadonly<CreateFolderInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/media-folders`, createFolderInputBody
    ] as const;
    }


export const getMediaFolderCreateQueryOptions = <TData = Awaited<ReturnType<typeof mediaFolderCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    createFolderInputBody: NonReadonly<CreateFolderInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaFolderCreateQueryKey(id,kind,createFolderInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaFolderCreate>>> = ({ signal }) => mediaFolderCreate(id,kind,createFolderInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaFolderCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaFolderCreateQueryResult = NonNullable<Awaited<ReturnType<typeof mediaFolderCreate>>>
export type MediaFolderCreateQueryError = ErrorModel


export function useMediaFolderCreate<TData = Awaited<ReturnType<typeof mediaFolderCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createFolderInputBody: NonReadonly<CreateFolderInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderCreate>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderCreate<TData = Awaited<ReturnType<typeof mediaFolderCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createFolderInputBody: NonReadonly<CreateFolderInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaFolderCreate>>,
          TError,
          Awaited<ReturnType<typeof mediaFolderCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaFolderCreate<TData = Awaited<ReturnType<typeof mediaFolderCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createFolderInputBody: NonReadonly<CreateFolderInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести папку
 */

export function useMediaFolderCreate<TData = Awaited<ReturnType<typeof mediaFolderCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createFolderInputBody: NonReadonly<CreateFolderInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaFolderCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaFolderCreateQueryOptions(id,kind,createFolderInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaOptimizationResponse200 = {
  data: OptimizationOutputBody
  status: 200
}

export type mediaOptimizationResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaOptimizationResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaOptimizationResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaOptimizationResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaOptimizationResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaOptimizationResponseSuccess = (mediaOptimizationResponse200) & {
  headers: Headers;
};
export type mediaOptimizationResponseError = (mediaOptimizationResponse401 | mediaOptimizationResponse403 | mediaOptimizationResponse404 | mediaOptimizationResponse422 | mediaOptimizationResponse500) & {
  headers: Headers;
};

export type mediaOptimizationResponse = (mediaOptimizationResponseSuccess | mediaOptimizationResponseError)

export const getMediaOptimizationUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/media-optimization`
}

/**
 * @summary Оптимизация медиа: настройки и состояние
 */
export const mediaOptimization = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<mediaOptimizationResponse> => {

  return facetaFetch<mediaOptimizationResponse>(getMediaOptimizationUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaOptimizationQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/media-optimization`
    ] as const;
    }


export const getMediaOptimizationQueryOptions = <TData = Awaited<ReturnType<typeof mediaOptimization>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimization>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaOptimizationQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaOptimization>>> = ({ signal }) => mediaOptimization(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaOptimization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaOptimizationQueryResult = NonNullable<Awaited<ReturnType<typeof mediaOptimization>>>
export type MediaOptimizationQueryError = ErrorModel


export function useMediaOptimization<TData = Awaited<ReturnType<typeof mediaOptimization>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaOptimization>>,
          TError,
          Awaited<ReturnType<typeof mediaOptimization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaOptimization<TData = Awaited<ReturnType<typeof mediaOptimization>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaOptimization>>,
          TError,
          Awaited<ReturnType<typeof mediaOptimization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaOptimization<TData = Awaited<ReturnType<typeof mediaOptimization>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimization>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Оптимизация медиа: настройки и состояние
 */

export function useMediaOptimization<TData = Awaited<ReturnType<typeof mediaOptimization>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimization>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaOptimizationQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaIDsResponse200 = {
  data: IDsOutputBody
  status: 200
}

export type mediaIDsResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaIDsResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaIDsResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaIDsResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaIDsResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaIDsResponseSuccess = (mediaIDsResponse200) & {
  headers: Headers;
};
export type mediaIDsResponseError = (mediaIDsResponse401 | mediaIDsResponse403 | mediaIDsResponse404 | mediaIDsResponse422 | mediaIDsResponse500) & {
  headers: Headers;
};

export type mediaIDsResponse = (mediaIDsResponseSuccess | mediaIDsResponseError)

export const getMediaIDsUrl = (id: string,
    kind: 'production' | 'development',
    params?: MediaIDsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/environments/${kind}/media/ids?${stringifiedParams}` : `/sites/${id}/environments/${kind}/media/ids`
}

/**
 * Идентификаторы всех файлов с теми же фильтрами, что у списка, — для «выбрать все».
 * @summary Все файлы вида
 */
export const mediaIDs = async (id: string,
    kind: 'production' | 'development',
    params?: MediaIDsParams, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaIDsResponse> => {

  return facetaFetch<mediaIDsResponse>(getMediaIDsUrl(id,kind,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaIDsQueryKey = (id: string,
    kind: 'production' | 'development',
    params?: MediaIDsParams,) => {
    return [
    `/sites/${id}/environments/${kind}/media/ids`, ...(params ? [params] : [])
    ] as const;
    }


export const getMediaIDsQueryOptions = <TData = Awaited<ReturnType<typeof mediaIDs>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    params?: MediaIDsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaIDs>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaIDsQueryKey(id,kind,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaIDs>>> = ({ signal }) => mediaIDs(id,kind,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaIDs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaIDsQueryResult = NonNullable<Awaited<ReturnType<typeof mediaIDs>>>
export type MediaIDsQueryError = ErrorModel


export function useMediaIDs<TData = Awaited<ReturnType<typeof mediaIDs>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params: undefined |  MediaIDsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaIDs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaIDs>>,
          TError,
          Awaited<ReturnType<typeof mediaIDs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaIDs<TData = Awaited<ReturnType<typeof mediaIDs>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaIDsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaIDs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaIDs>>,
          TError,
          Awaited<ReturnType<typeof mediaIDs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaIDs<TData = Awaited<ReturnType<typeof mediaIDs>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaIDsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaIDs>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Все файлы вида
 */

export function useMediaIDs<TData = Awaited<ReturnType<typeof mediaIDs>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: MediaIDsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaIDs>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaIDsQueryOptions(id,kind,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaMoveResponse200 = {
  data: MoveOutputBody
  status: 200
}

export type mediaMoveResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaMoveResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaMoveResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaMoveResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaMoveResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaMoveResponseSuccess = (mediaMoveResponse200) & {
  headers: Headers;
};
export type mediaMoveResponseError = (mediaMoveResponse401 | mediaMoveResponse403 | mediaMoveResponse404 | mediaMoveResponse422 | mediaMoveResponse500) & {
  headers: Headers;
};

export type mediaMoveResponse = (mediaMoveResponseSuccess | mediaMoveResponseError)

export const getMediaMoveUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/media/move`
}

/**
 * @summary Переложить файлы в папку
 */
export const mediaMove = async (id: string,
    kind: 'production' | 'development',
    moveInputBody: NonReadonly<MoveInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaMoveResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaMoveResponse>(getMediaMoveUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveInputBody)
  }
);}





export const getMediaMoveQueryKey = (id: string,
    kind: 'production' | 'development',
    moveInputBody?: NonReadonly<MoveInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/media/move`, moveInputBody
    ] as const;
    }


export const getMediaMoveQueryOptions = <TData = Awaited<ReturnType<typeof mediaMove>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    moveInputBody: NonReadonly<MoveInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaMove>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaMoveQueryKey(id,kind,moveInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaMove>>> = ({ signal }) => mediaMove(id,kind,moveInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaMove>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaMoveQueryResult = NonNullable<Awaited<ReturnType<typeof mediaMove>>>
export type MediaMoveQueryError = ErrorModel


export function useMediaMove<TData = Awaited<ReturnType<typeof mediaMove>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    moveInputBody: NonReadonly<MoveInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaMove>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaMove>>,
          TError,
          Awaited<ReturnType<typeof mediaMove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaMove<TData = Awaited<ReturnType<typeof mediaMove>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    moveInputBody: NonReadonly<MoveInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaMove>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaMove>>,
          TError,
          Awaited<ReturnType<typeof mediaMove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaMove<TData = Awaited<ReturnType<typeof mediaMove>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    moveInputBody: NonReadonly<MoveInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaMove>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Переложить файлы в папку
 */

export function useMediaMove<TData = Awaited<ReturnType<typeof mediaMove>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    moveInputBody: NonReadonly<MoveInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaMove>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaMoveQueryOptions(id,kind,moveInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaOptimizeResponse200 = {
  data: OptimizeOutputBody
  status: 200
}

export type mediaOptimizeResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaOptimizeResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaOptimizeResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaOptimizeResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaOptimizeResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaOptimizeResponseSuccess = (mediaOptimizeResponse200) & {
  headers: Headers;
};
export type mediaOptimizeResponseError = (mediaOptimizeResponse401 | mediaOptimizeResponse403 | mediaOptimizeResponse404 | mediaOptimizeResponse422 | mediaOptimizeResponse500) & {
  headers: Headers;
};

export type mediaOptimizeResponse = (mediaOptimizeResponseSuccess | mediaOptimizeResponseError)

export const getMediaOptimizeUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/media/optimize`
}

/**
 * Порцией по 10: ответ говорит, сколько осталось, — экран повторяет запрос, показывая ход. Картинки, которые не сжимаются (gif, svg, уже лёгкие), отмечаются проверенными.
 * @summary Сжать уже загруженные картинки
 */
export const mediaOptimize = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<mediaOptimizeResponse> => {

  return facetaFetch<mediaOptimizeResponse>(getMediaOptimizeUrl(id,kind),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMediaOptimizeQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/media/optimize`
    ] as const;
    }


export const getMediaOptimizeQueryOptions = <TData = Awaited<ReturnType<typeof mediaOptimize>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimize>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaOptimizeQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaOptimize>>> = ({ signal }) => mediaOptimize(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaOptimize>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaOptimizeQueryResult = NonNullable<Awaited<ReturnType<typeof mediaOptimize>>>
export type MediaOptimizeQueryError = ErrorModel


export function useMediaOptimize<TData = Awaited<ReturnType<typeof mediaOptimize>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimize>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaOptimize>>,
          TError,
          Awaited<ReturnType<typeof mediaOptimize>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaOptimize<TData = Awaited<ReturnType<typeof mediaOptimize>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimize>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaOptimize>>,
          TError,
          Awaited<ReturnType<typeof mediaOptimize>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaOptimize<TData = Awaited<ReturnType<typeof mediaOptimize>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimize>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сжать уже загруженные картинки
 */

export function useMediaOptimize<TData = Awaited<ReturnType<typeof mediaOptimize>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaOptimize>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaOptimizeQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaPurgeResponse200 = {
  data: PurgeOutputBody
  status: 200
}

export type mediaPurgeResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaPurgeResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaPurgeResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaPurgeResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaPurgeResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaPurgeResponseSuccess = (mediaPurgeResponse200) & {
  headers: Headers;
};
export type mediaPurgeResponseError = (mediaPurgeResponse401 | mediaPurgeResponse403 | mediaPurgeResponse404 | mediaPurgeResponse422 | mediaPurgeResponse500) & {
  headers: Headers;
};

export type mediaPurgeResponse = (mediaPurgeResponseSuccess | mediaPurgeResponseError)

export const getMediaPurgeUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/media/purge`
}

/**
 * Только то, что уже в корзине: живые файлы не удаляются, даже если их id в списке. Файл стирается с диска, если на него не ссылается копия в другом окружении. Вернуть нельзя.
 * @summary Удалить из корзины навсегда
 */
export const mediaPurge = async (id: string,
    kind: 'production' | 'development',
    purgeInputBody: NonReadonly<PurgeInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaPurgeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaPurgeResponse>(getMediaPurgeUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(purgeInputBody)
  }
);}





export const getMediaPurgeQueryKey = (id: string,
    kind: 'production' | 'development',
    purgeInputBody?: NonReadonly<PurgeInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/media/purge`, purgeInputBody
    ] as const;
    }


export const getMediaPurgeQueryOptions = <TData = Awaited<ReturnType<typeof mediaPurge>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    purgeInputBody: NonReadonly<PurgeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPurge>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaPurgeQueryKey(id,kind,purgeInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaPurge>>> = ({ signal }) => mediaPurge(id,kind,purgeInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaPurge>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaPurgeQueryResult = NonNullable<Awaited<ReturnType<typeof mediaPurge>>>
export type MediaPurgeQueryError = ErrorModel


export function useMediaPurge<TData = Awaited<ReturnType<typeof mediaPurge>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    purgeInputBody: NonReadonly<PurgeInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPurge>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaPurge>>,
          TError,
          Awaited<ReturnType<typeof mediaPurge>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaPurge<TData = Awaited<ReturnType<typeof mediaPurge>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    purgeInputBody: NonReadonly<PurgeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPurge>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaPurge>>,
          TError,
          Awaited<ReturnType<typeof mediaPurge>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaPurge<TData = Awaited<ReturnType<typeof mediaPurge>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    purgeInputBody: NonReadonly<PurgeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPurge>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить из корзины навсегда
 */

export function useMediaPurge<TData = Awaited<ReturnType<typeof mediaPurge>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    purgeInputBody: NonReadonly<PurgeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaPurge>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaPurgeQueryOptions(id,kind,purgeInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaRestoreManyResponse200 = {
  data: SelectionOutputBody
  status: 200
}

export type mediaRestoreManyResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaRestoreManyResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaRestoreManyResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaRestoreManyResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaRestoreManyResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaRestoreManyResponseSuccess = (mediaRestoreManyResponse200) & {
  headers: Headers;
};
export type mediaRestoreManyResponseError = (mediaRestoreManyResponse401 | mediaRestoreManyResponse403 | mediaRestoreManyResponse404 | mediaRestoreManyResponse422 | mediaRestoreManyResponse500) & {
  headers: Headers;
};

export type mediaRestoreManyResponse = (mediaRestoreManyResponseSuccess | mediaRestoreManyResponseError)

export const getMediaRestoreManyUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/media/restore`
}

/**
 * @summary Вернуть из корзины — разом
 */
export const mediaRestoreMany = async (id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaRestoreManyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaRestoreManyResponse>(getMediaRestoreManyUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(selectionInputBody)
  }
);}





export const getMediaRestoreManyQueryKey = (id: string,
    kind: 'production' | 'development',
    selectionInputBody?: NonReadonly<SelectionInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/media/restore`, selectionInputBody
    ] as const;
    }


export const getMediaRestoreManyQueryOptions = <TData = Awaited<ReturnType<typeof mediaRestoreMany>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestoreMany>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaRestoreManyQueryKey(id,kind,selectionInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaRestoreMany>>> = ({ signal }) => mediaRestoreMany(id,kind,selectionInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaRestoreMany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaRestoreManyQueryResult = NonNullable<Awaited<ReturnType<typeof mediaRestoreMany>>>
export type MediaRestoreManyQueryError = ErrorModel


export function useMediaRestoreMany<TData = Awaited<ReturnType<typeof mediaRestoreMany>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestoreMany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaRestoreMany>>,
          TError,
          Awaited<ReturnType<typeof mediaRestoreMany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaRestoreMany<TData = Awaited<ReturnType<typeof mediaRestoreMany>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestoreMany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaRestoreMany>>,
          TError,
          Awaited<ReturnType<typeof mediaRestoreMany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaRestoreMany<TData = Awaited<ReturnType<typeof mediaRestoreMany>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestoreMany>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вернуть из корзины — разом
 */

export function useMediaRestoreMany<TData = Awaited<ReturnType<typeof mediaRestoreMany>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRestoreMany>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaRestoreManyQueryOptions(id,kind,selectionInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaTrashManyResponse200 = {
  data: SelectionOutputBody
  status: 200
}

export type mediaTrashManyResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaTrashManyResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaTrashManyResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaTrashManyResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaTrashManyResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaTrashManyResponseSuccess = (mediaTrashManyResponse200) & {
  headers: Headers;
};
export type mediaTrashManyResponseError = (mediaTrashManyResponse401 | mediaTrashManyResponse403 | mediaTrashManyResponse404 | mediaTrashManyResponse422 | mediaTrashManyResponse500) & {
  headers: Headers;
};

export type mediaTrashManyResponse = (mediaTrashManyResponseSuccess | mediaTrashManyResponseError)

export const getMediaTrashManyUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/media/trash`
}

/**
 * @summary В корзину — разом
 */
export const mediaTrashMany = async (id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaTrashManyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaTrashManyResponse>(getMediaTrashManyUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(selectionInputBody)
  }
);}





export const getMediaTrashManyQueryKey = (id: string,
    kind: 'production' | 'development',
    selectionInputBody?: NonReadonly<SelectionInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/media/trash`, selectionInputBody
    ] as const;
    }


export const getMediaTrashManyQueryOptions = <TData = Awaited<ReturnType<typeof mediaTrashMany>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaTrashMany>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaTrashManyQueryKey(id,kind,selectionInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaTrashMany>>> = ({ signal }) => mediaTrashMany(id,kind,selectionInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaTrashMany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaTrashManyQueryResult = NonNullable<Awaited<ReturnType<typeof mediaTrashMany>>>
export type MediaTrashManyQueryError = ErrorModel


export function useMediaTrashMany<TData = Awaited<ReturnType<typeof mediaTrashMany>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaTrashMany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaTrashMany>>,
          TError,
          Awaited<ReturnType<typeof mediaTrashMany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaTrashMany<TData = Awaited<ReturnType<typeof mediaTrashMany>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaTrashMany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaTrashMany>>,
          TError,
          Awaited<ReturnType<typeof mediaTrashMany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaTrashMany<TData = Awaited<ReturnType<typeof mediaTrashMany>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaTrashMany>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary В корзину — разом
 */

export function useMediaTrashMany<TData = Awaited<ReturnType<typeof mediaTrashMany>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    selectionInputBody: NonReadonly<SelectionInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaTrashMany>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaTrashManyQueryOptions(id,kind,selectionInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaUploadStartResponse201 = {
  data: UploadBody
  status: 201
}

export type mediaUploadStartResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaUploadStartResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaUploadStartResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaUploadStartResponse413 = {
  data: ErrorModel
  status: 413
}

export type mediaUploadStartResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaUploadStartResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaUploadStartResponseSuccess = (mediaUploadStartResponse201) & {
  headers: Headers;
};
export type mediaUploadStartResponseError = (mediaUploadStartResponse401 | mediaUploadStartResponse403 | mediaUploadStartResponse404 | mediaUploadStartResponse413 | mediaUploadStartResponse422 | mediaUploadStartResponse500) & {
  headers: Headers;
};

export type mediaUploadStartResponse = (mediaUploadStartResponseSuccess | mediaUploadStartResponseError)

export const getMediaUploadStartUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/uploads`
}

/**
 * Для файлов больше 20 МБ — видео, длинное аудио. Не больше 2 ГБ.
 * @summary Начать загрузку частями
 */
export const mediaUploadStart = async (id: string,
    kind: 'production' | 'development',
    startUploadInputBody: NonReadonly<StartUploadInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaUploadStartResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaUploadStartResponse>(getMediaUploadStartUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startUploadInputBody)
  }
);}





export const getMediaUploadStartQueryKey = (id: string,
    kind: 'production' | 'development',
    startUploadInputBody?: NonReadonly<StartUploadInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/uploads`, startUploadInputBody
    ] as const;
    }


export const getMediaUploadStartQueryOptions = <TData = Awaited<ReturnType<typeof mediaUploadStart>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    startUploadInputBody: NonReadonly<StartUploadInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStart>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaUploadStartQueryKey(id,kind,startUploadInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaUploadStart>>> = ({ signal }) => mediaUploadStart(id,kind,startUploadInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaUploadStartQueryResult = NonNullable<Awaited<ReturnType<typeof mediaUploadStart>>>
export type MediaUploadStartQueryError = ErrorModel


export function useMediaUploadStart<TData = Awaited<ReturnType<typeof mediaUploadStart>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    startUploadInputBody: NonReadonly<StartUploadInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadStart>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadStart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadStart<TData = Awaited<ReturnType<typeof mediaUploadStart>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    startUploadInputBody: NonReadonly<StartUploadInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadStart>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadStart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadStart<TData = Awaited<ReturnType<typeof mediaUploadStart>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    startUploadInputBody: NonReadonly<StartUploadInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStart>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Начать загрузку частями
 */

export function useMediaUploadStart<TData = Awaited<ReturnType<typeof mediaUploadStart>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    startUploadInputBody: NonReadonly<StartUploadInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStart>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaUploadStartQueryOptions(id,kind,startUploadInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaSetSettingsResponse200 = {
  data: OptimizationOutputBody
  status: 200
}

export type mediaSetSettingsResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaSetSettingsResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaSetSettingsResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaSetSettingsResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaSetSettingsResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaSetSettingsResponseSuccess = (mediaSetSettingsResponse200) & {
  headers: Headers;
};
export type mediaSetSettingsResponseError = (mediaSetSettingsResponse401 | mediaSetSettingsResponse403 | mediaSetSettingsResponse404 | mediaSetSettingsResponse422 | mediaSetSettingsResponse500) & {
  headers: Headers;
};

export type mediaSetSettingsResponse = (mediaSetSettingsResponseSuccess | mediaSetSettingsResponseError)

export const getMediaSetSettingsUrl = (id: string,) => {




  return `/sites/${id}/media-settings`
}

/**
 * Общие для обоих окружений: как сжимать картинки при загрузке, какие форматы отдавать сайту, перекодировать ли видео.
 * @summary Настройки обработки медиа
 */
export const mediaSetSettings = async (id: string,
    settingsBody: NonReadonly<SettingsBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaSetSettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaSetSettingsResponse>(getMediaSetSettingsUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(settingsBody)
  }
);}





export const getMediaSetSettingsQueryKey = (id: string,
    settingsBody?: NonReadonly<SettingsBody>,) => {
    return [
    'PUT', `/sites/${id}/media-settings`, settingsBody
    ] as const;
    }


export const getMediaSetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof mediaSetSettings>>, TError = ErrorModel>(id: string,
    settingsBody: NonReadonly<SettingsBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSetSettings>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaSetSettingsQueryKey(id,settingsBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaSetSettings>>> = ({ signal }) => mediaSetSettings(id,settingsBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaSetSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaSetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof mediaSetSettings>>>
export type MediaSetSettingsQueryError = ErrorModel


export function useMediaSetSettings<TData = Awaited<ReturnType<typeof mediaSetSettings>>, TError = ErrorModel>(
 id: string,
    settingsBody: NonReadonly<SettingsBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSetSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaSetSettings>>,
          TError,
          Awaited<ReturnType<typeof mediaSetSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaSetSettings<TData = Awaited<ReturnType<typeof mediaSetSettings>>, TError = ErrorModel>(
 id: string,
    settingsBody: NonReadonly<SettingsBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSetSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaSetSettings>>,
          TError,
          Awaited<ReturnType<typeof mediaSetSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaSetSettings<TData = Awaited<ReturnType<typeof mediaSetSettings>>, TError = ErrorModel>(
 id: string,
    settingsBody: NonReadonly<SettingsBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSetSettings>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Настройки обработки медиа
 */

export function useMediaSetSettings<TData = Awaited<ReturnType<typeof mediaSetSettings>>, TError = ErrorModel>(
 id: string,
    settingsBody: NonReadonly<SettingsBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSetSettings>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaSetSettingsQueryOptions(id,settingsBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaSpaceResponse200 = {
  data: SpaceOutputBody
  status: 200
}

export type mediaSpaceResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaSpaceResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaSpaceResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaSpaceResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaSpaceResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaSpaceResponseSuccess = (mediaSpaceResponse200) & {
  headers: Headers;
};
export type mediaSpaceResponseError = (mediaSpaceResponse401 | mediaSpaceResponse403 | mediaSpaceResponse404 | mediaSpaceResponse422 | mediaSpaceResponse500) & {
  headers: Headers;
};

export type mediaSpaceResponse = (mediaSpaceResponseSuccess | mediaSpaceResponseError)

export const getMediaSpaceUrl = (id: string,) => {




  return `/sites/${id}/media-space`
}

/**
 * По окружениям — живые файлы и корзина; всего — сколько лежит в хранилище (копия файла в деве и проде — один объект). Куски HLS не в счёте.
 * @summary Сколько места занимают файлы сайта
 */
export const mediaSpace = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaSpaceResponse> => {

  return facetaFetch<mediaSpaceResponse>(getMediaSpaceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaSpaceQueryKey = (id: string,) => {
    return [
    `/sites/${id}/media-space`
    ] as const;
    }


export const getMediaSpaceQueryOptions = <TData = Awaited<ReturnType<typeof mediaSpace>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSpace>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaSpaceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaSpace>>> = ({ signal }) => mediaSpace(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaSpace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaSpaceQueryResult = NonNullable<Awaited<ReturnType<typeof mediaSpace>>>
export type MediaSpaceQueryError = ErrorModel


export function useMediaSpace<TData = Awaited<ReturnType<typeof mediaSpace>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSpace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaSpace>>,
          TError,
          Awaited<ReturnType<typeof mediaSpace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaSpace<TData = Awaited<ReturnType<typeof mediaSpace>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSpace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaSpace>>,
          TError,
          Awaited<ReturnType<typeof mediaSpace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaSpace<TData = Awaited<ReturnType<typeof mediaSpace>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSpace>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сколько места занимают файлы сайта
 */

export function useMediaSpace<TData = Awaited<ReturnType<typeof mediaSpace>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaSpace>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaSpaceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaUploadCancelResponse204 = {
  data: void
  status: 204
}

export type mediaUploadCancelResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaUploadCancelResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaUploadCancelResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaUploadCancelResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaUploadCancelResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaUploadCancelResponseSuccess = (mediaUploadCancelResponse204) & {
  headers: Headers;
};
export type mediaUploadCancelResponseError = (mediaUploadCancelResponse401 | mediaUploadCancelResponse403 | mediaUploadCancelResponse404 | mediaUploadCancelResponse422 | mediaUploadCancelResponse500) & {
  headers: Headers;
};

export type mediaUploadCancelResponse = (mediaUploadCancelResponseSuccess | mediaUploadCancelResponseError)

export const getMediaUploadCancelUrl = (uploadId: string,) => {




  return `/uploads/${uploadId}`
}

/**
 * @summary Отменить загрузку
 */
export const mediaUploadCancel = async (uploadId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaUploadCancelResponse> => {

  return facetaFetch<mediaUploadCancelResponse>(getMediaUploadCancelUrl(uploadId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMediaUploadCancelQueryKey = (uploadId: string,) => {
    return [
    'DELETE', `/uploads/${uploadId}`
    ] as const;
    }


export const getMediaUploadCancelQueryOptions = <TData = Awaited<ReturnType<typeof mediaUploadCancel>>, TError = ErrorModel>(uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadCancel>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaUploadCancelQueryKey(uploadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaUploadCancel>>> = ({ signal }) => mediaUploadCancel(uploadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uploadId !== null && uploadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaUploadCancel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaUploadCancelQueryResult = NonNullable<Awaited<ReturnType<typeof mediaUploadCancel>>>
export type MediaUploadCancelQueryError = ErrorModel


export function useMediaUploadCancel<TData = Awaited<ReturnType<typeof mediaUploadCancel>>, TError = ErrorModel>(
 uploadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadCancel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadCancel>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadCancel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadCancel<TData = Awaited<ReturnType<typeof mediaUploadCancel>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadCancel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadCancel>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadCancel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadCancel<TData = Awaited<ReturnType<typeof mediaUploadCancel>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadCancel>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отменить загрузку
 */

export function useMediaUploadCancel<TData = Awaited<ReturnType<typeof mediaUploadCancel>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadCancel>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaUploadCancelQueryOptions(uploadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaUploadStatusResponse200 = {
  data: UploadBody
  status: 200
}

export type mediaUploadStatusResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaUploadStatusResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaUploadStatusResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaUploadStatusResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaUploadStatusResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaUploadStatusResponseSuccess = (mediaUploadStatusResponse200) & {
  headers: Headers;
};
export type mediaUploadStatusResponseError = (mediaUploadStatusResponse401 | mediaUploadStatusResponse403 | mediaUploadStatusResponse404 | mediaUploadStatusResponse422 | mediaUploadStatusResponse500) & {
  headers: Headers;
};

export type mediaUploadStatusResponse = (mediaUploadStatusResponseSuccess | mediaUploadStatusResponseError)

export const getMediaUploadStatusUrl = (uploadId: string,) => {




  return `/uploads/${uploadId}`
}

/**
 * @summary Сколько принято — чтобы продолжить после обрыва
 */
export const mediaUploadStatus = async (uploadId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaUploadStatusResponse> => {

  return facetaFetch<mediaUploadStatusResponse>(getMediaUploadStatusUrl(uploadId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaUploadStatusQueryKey = (uploadId: string,) => {
    return [
    `/uploads/${uploadId}`
    ] as const;
    }


export const getMediaUploadStatusQueryOptions = <TData = Awaited<ReturnType<typeof mediaUploadStatus>>, TError = ErrorModel>(uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaUploadStatusQueryKey(uploadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaUploadStatus>>> = ({ signal }) => mediaUploadStatus(uploadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uploadId !== null && uploadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaUploadStatusQueryResult = NonNullable<Awaited<ReturnType<typeof mediaUploadStatus>>>
export type MediaUploadStatusQueryError = ErrorModel


export function useMediaUploadStatus<TData = Awaited<ReturnType<typeof mediaUploadStatus>>, TError = ErrorModel>(
 uploadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadStatus>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadStatus<TData = Awaited<ReturnType<typeof mediaUploadStatus>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadStatus>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadStatus<TData = Awaited<ReturnType<typeof mediaUploadStatus>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сколько принято — чтобы продолжить после обрыва
 */

export function useMediaUploadStatus<TData = Awaited<ReturnType<typeof mediaUploadStatus>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaUploadStatusQueryOptions(uploadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaUploadChunkResponse200 = {
  data: UploadBody
  status: 200
}

export type mediaUploadChunkResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaUploadChunkResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaUploadChunkResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaUploadChunkResponse409 = {
  data: ErrorModel
  status: 409
}

export type mediaUploadChunkResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaUploadChunkResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaUploadChunkResponseSuccess = (mediaUploadChunkResponse200) & {
  headers: Headers;
};
export type mediaUploadChunkResponseError = (mediaUploadChunkResponse401 | mediaUploadChunkResponse403 | mediaUploadChunkResponse404 | mediaUploadChunkResponse409 | mediaUploadChunkResponse422 | mediaUploadChunkResponse500) & {
  headers: Headers;
};

export type mediaUploadChunkResponse = (mediaUploadChunkResponseSuccess | mediaUploadChunkResponseError)

export const getMediaUploadChunkUrl = (uploadId: string,
    params?: MediaUploadChunkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/uploads/${uploadId}?${stringifiedParams}` : `/uploads/${uploadId}`
}

/**
 * Кусок с места offset; offset должен совпасть с тем, сколько уже принято, иначе 409 — спросите состояние и продолжите оттуда. Повторно присланный кусок не портит файл.
 * @summary Принять кусок
 */
export const mediaUploadChunk = async (uploadId: string,
    mediaUploadChunkBody: Blob,
    params?: MediaUploadChunkParams, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaUploadChunkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<mediaUploadChunkResponse>(getMediaUploadChunkUrl(uploadId,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/octet-stream', ...getHeaders(options?.headers) },
    body: mediaUploadChunkBody
  }
);}





export const getMediaUploadChunkQueryKey = (uploadId: string,
    mediaUploadChunkBody?: Blob,
    params?: MediaUploadChunkParams,) => {
    return [
    'PUT', `/uploads/${uploadId}`, ...(params ? [params] : []), mediaUploadChunkBody
    ] as const;
    }


export const getMediaUploadChunkQueryOptions = <TData = Awaited<ReturnType<typeof mediaUploadChunk>>, TError = ErrorModel>(uploadId: string,
    mediaUploadChunkBody: Blob,
    params?: MediaUploadChunkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadChunk>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaUploadChunkQueryKey(uploadId,mediaUploadChunkBody,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaUploadChunk>>> = ({ signal }) => mediaUploadChunk(uploadId,mediaUploadChunkBody,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uploadId !== null && uploadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaUploadChunk>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaUploadChunkQueryResult = NonNullable<Awaited<ReturnType<typeof mediaUploadChunk>>>
export type MediaUploadChunkQueryError = ErrorModel


export function useMediaUploadChunk<TData = Awaited<ReturnType<typeof mediaUploadChunk>>, TError = ErrorModel>(
 uploadId: string,
    mediaUploadChunkBody: Blob,
    params: undefined |  MediaUploadChunkParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadChunk>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadChunk>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadChunk>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadChunk<TData = Awaited<ReturnType<typeof mediaUploadChunk>>, TError = ErrorModel>(
 uploadId: string,
    mediaUploadChunkBody: Blob,
    params?: MediaUploadChunkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadChunk>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadChunk>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadChunk>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadChunk<TData = Awaited<ReturnType<typeof mediaUploadChunk>>, TError = ErrorModel>(
 uploadId: string,
    mediaUploadChunkBody: Blob,
    params?: MediaUploadChunkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadChunk>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Принять кусок
 */

export function useMediaUploadChunk<TData = Awaited<ReturnType<typeof mediaUploadChunk>>, TError = ErrorModel>(
 uploadId: string,
    mediaUploadChunkBody: Blob,
    params?: MediaUploadChunkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadChunk>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaUploadChunkQueryOptions(uploadId,mediaUploadChunkBody,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type mediaUploadCompleteResponse201 = {
  data: AssetBody
  status: 201
}

export type mediaUploadCompleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type mediaUploadCompleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type mediaUploadCompleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type mediaUploadCompleteResponse409 = {
  data: ErrorModel
  status: 409
}

export type mediaUploadCompleteResponse413 = {
  data: ErrorModel
  status: 413
}

export type mediaUploadCompleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type mediaUploadCompleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type mediaUploadCompleteResponseSuccess = (mediaUploadCompleteResponse201) & {
  headers: Headers;
};
export type mediaUploadCompleteResponseError = (mediaUploadCompleteResponse401 | mediaUploadCompleteResponse403 | mediaUploadCompleteResponse404 | mediaUploadCompleteResponse409 | mediaUploadCompleteResponse413 | mediaUploadCompleteResponse422 | mediaUploadCompleteResponse500) & {
  headers: Headers;
};

export type mediaUploadCompleteResponse = (mediaUploadCompleteResponseSuccess | mediaUploadCompleteResponseError)

export const getMediaUploadCompleteUrl = (uploadId: string,) => {




  return `/uploads/${uploadId}/complete`
}

/**
 * Вид — по содержимому; предел размера — по виду (видео — 2 ГБ, аудио — 200 МБ).
 * @summary Собрать файл
 */
export const mediaUploadComplete = async (uploadId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<mediaUploadCompleteResponse> => {

  return facetaFetch<mediaUploadCompleteResponse>(getMediaUploadCompleteUrl(uploadId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMediaUploadCompleteQueryKey = (uploadId: string,) => {
    return [
    'POST', `/uploads/${uploadId}/complete`
    ] as const;
    }


export const getMediaUploadCompleteQueryOptions = <TData = Awaited<ReturnType<typeof mediaUploadComplete>>, TError = ErrorModel>(uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadComplete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaUploadCompleteQueryKey(uploadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaUploadComplete>>> = ({ signal }) => mediaUploadComplete(uploadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uploadId !== null && uploadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaUploadComplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaUploadCompleteQueryResult = NonNullable<Awaited<ReturnType<typeof mediaUploadComplete>>>
export type MediaUploadCompleteQueryError = ErrorModel


export function useMediaUploadComplete<TData = Awaited<ReturnType<typeof mediaUploadComplete>>, TError = ErrorModel>(
 uploadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadComplete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadComplete>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadComplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadComplete<TData = Awaited<ReturnType<typeof mediaUploadComplete>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadComplete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaUploadComplete>>,
          TError,
          Awaited<ReturnType<typeof mediaUploadComplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaUploadComplete<TData = Awaited<ReturnType<typeof mediaUploadComplete>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadComplete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Собрать файл
 */

export function useMediaUploadComplete<TData = Awaited<ReturnType<typeof mediaUploadComplete>>, TError = ErrorModel>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaUploadComplete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaUploadCompleteQueryOptions(uploadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






